var map = {
	"./EVO.png": 1671,
	"./Path 20295.png": 1672,
	"./ab-img.webp": 1673,
	"./ab-title-cn.webp": 1674,
	"./ab-title-en.webp": 1675,
	"./ag-img.png": 1676,
	"./ag-img.webp": 1677,
	"./ag-title-cn.webp": 1678,
	"./ag-title-en.webp": 1679,
	"./chess-img.webp": 1680,
	"./coin-img.webp": 1681,
	"./content-img.webp": 1682,
	"./dg-img.webp": 1683,
	"./dg-title-cn.webp": 1684,
	"./dg-title-en.webp": 1685,
	"./diamond-img.webp": 1686,
	"./dice-coin.webp": 1687,
	"./ea-img.webp": 1688,
	"./ea-title-cn.webp": 1689,
	"./ea-title-en.webp": 1690,
	"./evo-img.webp": 1691,
	"./evo-title-cn.webp": 1692,
	"./evo-title-en.webp": 1693,
	"./golddice-img.webp": 1694,
	"./gp-img.webp": 1695,
	"./gp-title-cn.webp": 1696,
	"./gp-title-en.webp": 1697,
	"./heart-coin-img.webp": 1698,
	"./lc-bg.webp": 1699,
	"./mg-img.webp": 1700,
	"./mg-title-cn.webp": 1701,
	"./mg-title-en.webp": 1702,
	"./pp-img.webp": 1703,
	"./pp-title-cn.webp": 1704,
	"./pp-title-en.webp": 1705,
	"./pt-img.webp": 1706,
	"./pt-title-cn.webp": 1707,
	"./pt-title-en.webp": 1708,
	"./sa-img.webp": 1709,
	"./sa-title-cn.webp": 1710,
	"./sa-title-en.webp": 1711,
	"./sbo-img.webp": 1712,
	"./sbo-title-cn.webp": 1713,
	"./sbo-title-en.webp": 1714,
	"./spade-img.webp": 1715,
	"./title-cn.webp": 1716,
	"./title-en.webp": 1717,
	"./white-spade-img.webp": 1718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1670;